module.exports = __webpack_public_path__ + "img/google.ca69d283.svg";